module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl10px pr10px"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("设备ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayDeviceid),
      expression: "displayDeviceid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.displayDeviceid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayDeviceid = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*设备编号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.deviceInfo.deviceNum.$error
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.deviceInfo.deviceNum),
      expression: "deviceInfo.deviceNum",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.deviceInfo.deviceNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "deviceNum", $event.target.value.trim())
      }, function($event) {
        return _vm.$v.deviceInfo.deviceNum.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.deviceInfo.deviceNum.required && _vm.$v.deviceInfo.deviceNum.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("设备编号为必填项")]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*设备类型")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.deviceInfo.obdFlag.$error
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.obdFlag),
      expression: "deviceInfo.obdFlag"
    }],
    staticClass: "form-control",
    on: {
      "input": function($event) {
        return _vm.$v.deviceInfo.obdFlag.$touch()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.deviceInfo, "obdFlag", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.OBDType), function(option) {
    return _c('option', {
      domProps: {
        "value": option.udccode
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.udcname) + "\n\t\t\t\t\t")])
  }), 0), _vm._v(" "), (!_vm.$v.deviceInfo.obdFlag.required && _vm.$v.deviceInfo.obdFlag.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("设备类型为必填项")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*品牌")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.deviceInfo.brandCode.$error
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.brandCode),
      expression: "deviceInfo.brandCode"
    }],
    staticClass: "form-control",
    on: {
      "input": function($event) {
        return _vm.$v.deviceInfo.brandCode.$touch()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.deviceInfo, "brandCode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.deviceBrand), function(option) {
    return _c('option', {
      domProps: {
        "value": option.brandCode
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.brandName) + "\n\t\t\t\t\t")])
  }), 0), _vm._v(" "), (!_vm.$v.deviceInfo.brandCode.required && _vm.$v.deviceInfo.brandCode.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("品牌为必填项")]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*型号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.deviceInfo.categoryId.$error
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.categoryId),
      expression: "deviceInfo.categoryId"
    }],
    staticClass: "form-control",
    on: {
      "input": function($event) {
        return _vm.$v.deviceInfo.categoryId.$touch()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.deviceInfo, "categoryId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.deviceCategory), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.categoryNo) + "\n\t\t\t\t\t")])
  }), 0), _vm._v(" "), (!_vm.$v.deviceInfo.categoryId.required && _vm.$v.deviceInfo.categoryId.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("型号为必填项")]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*有线无线")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.deviceInfo.wifiFlag.$error
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.wifiFlag),
      expression: "deviceInfo.wifiFlag"
    }],
    staticClass: "form-control",
    on: {
      "input": function($event) {
        return _vm.$v.deviceInfo.wifiFlag.$touch()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.deviceInfo, "wifiFlag", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.wifiType), function(option) {
    return _c('option', {
      domProps: {
        "value": option.udccode
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.udcname) + "\n\t\t\t\t\t")])
  }), 0), _vm._v(" "), (!_vm.$v.deviceInfo.wifiFlag.required && _vm.$v.deviceInfo.wifiFlag.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("有线无线为必填项")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*接线方式")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.deviceInfo.wiringMode.$error
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.wiringMode),
      expression: "deviceInfo.wiringMode"
    }],
    staticClass: "form-control",
    on: {
      "input": function($event) {
        return _vm.$v.deviceInfo.wiringMode.$touch()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.deviceInfo, "wiringMode", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.wiringType), function(option) {
    return _c('option', {
      domProps: {
        "value": option.udccode
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.udcname) + "\n\t\t\t\t\t")])
  }), 0), _vm._v(" "), (!_vm.$v.deviceInfo.wiringMode.required && _vm.$v.deviceInfo.wiringMode.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("接线方式为必填项")]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*设备协议")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.deviceInfo.protocolId.$error
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.protocolId),
      expression: "deviceInfo.protocolId"
    }],
    staticClass: "form-control",
    on: {
      "input": function($event) {
        return _vm.$v.deviceInfo.protocolId.$touch()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.deviceInfo, "protocolId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.protocol), function(option) {
    return _c('option', {
      domProps: {
        "value": option.protocolId
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.deviceProtocol) + "\n\t\t\t\t\t")])
  }), 0), _vm._v(" "), (!_vm.$v.deviceInfo.protocolId.required && _vm.$v.deviceInfo.protocolId.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("设备协议为必填项")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb5px"
  }, [(_vm.levv == 1) ? _c('div', {
    key: "user-didi",
    staticClass: "col-sm-12 text-right"
  }, [(_vm.permissionD.indexOf('fileCarList_deviceDetailRefresh1') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.refreshMileage
    }
  }, [_vm._v("刷新")]) : _vm._e()]) : _c('div', {
    key: "user-rb",
    staticClass: "col-sm-12 text-right"
  }, [(_vm.permission.indexOf('carFileList_deviceDetailRefresh1') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.refreshMileage
    }
  }, [_vm._v("刷新")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal ibox-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*初始里程")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.deviceInfo.initMileage.$error
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.deviceInfo.initMileage),
      expression: "deviceInfo.initMileage",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.deviceInfo.initMileage)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "initMileage", $event.target.value.trim())
      }, function($event) {
        return _vm.$v.deviceInfo.initMileage.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.deviceInfo.initMileage.required && _vm.$v.deviceInfo.initMileage.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("初始里程为必填项")]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("里程校准系数")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.correctDiff),
      expression: "deviceInfo.correctDiff"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.correctDiff)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "correctDiff", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("OBD里程")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.obdMileage),
      expression: "deviceInfo.obdMileage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.obdMileage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "obdMileage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('radio', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "true-value": "2"
    },
    model: {
      value: (_vm.deviceInfo.mileageType),
      callback: function($$v) {
        _vm.$set(_vm.deviceInfo, "mileageType", $$v)
      },
      expression: "deviceInfo.mileageType"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("GPS里程")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.hardMileage),
      expression: "deviceInfo.hardMileage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.hardMileage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "hardMileage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('radio', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "true-value": "3"
    },
    model: {
      value: (_vm.deviceInfo.mileageType),
      callback: function($$v) {
        _vm.$set(_vm.deviceInfo, "mileageType", $$v)
      },
      expression: "deviceInfo.mileageType"
    }
  })], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("软件里程")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.totilMileage),
      expression: "deviceInfo.totilMileage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.totilMileage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "totilMileage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('radio', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "true-value": "1"
    },
    model: {
      value: (_vm.deviceInfo.mileageType),
      callback: function($$v) {
        _vm.$set(_vm.deviceInfo, "mileageType", $$v)
      },
      expression: "deviceInfo.mileageType"
    }
  })], 1)])]), _vm._v(" "), (_vm.deviceInfo.wifiFlag == '2') ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal ibox-content"
  }, [_c('div', {
    staticClass: "form-group mb0px"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("模式设置")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInsts),
      expression: "curInsts"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.curInsts = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.insts), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(option.name) + "\n\t\t\t\t\t\t\t")])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.uploadModelSetting
    }
  }, [_vm._v("设置")])])])]), _vm._v(" "), _c('span', {
    staticClass: "col-sm-8 control-label gray t_left"
  }, [_vm._v("目前仅用于GT740和BK200两种型号的设备")])])]), _vm._v(" "), _c('div', {
    staticClass: "hr-line-dashed",
    staticStyle: {
      "background": "#DDDDDD",
      "color": "#fff"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.deviceInfo.wifiFlag == '1') ? _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal ibox-content"
  }, [_c('div', {
    staticClass: "form-group mb0px"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*上传间隔")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.deviceInfo.sendInterval),
      expression: "deviceInfo.sendInterval",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.deviceInfo.sendInterval)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "sendInterval", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block"
  }, [_vm._v("单位:秒")])])])]), _vm._v(" "), _c('div', {
    staticClass: "hr-line-dashed",
    staticStyle: {
      "background": "#DDDDDD",
      "color": "#fff"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group mb5px mt5px"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label gray t_left"
  }, [_vm._v("设备当前位置")]), _vm._v(" "), (_vm.levv == 1) ? _c('div', {
    key: "user-didi",
    staticClass: "col-sm-7 text-right"
  }, [(_vm.permissionD.indexOf('fileCarList_deviceDetailRefresh2') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.refreshMileage
    }
  }, [_vm._v("刷新")]) : _vm._e()]) : _c('div', {
    key: "user-rb",
    staticClass: "col-sm-7 text-right"
  }, [(_vm.permission.indexOf('carFileList_deviceDetailRefresh2') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.refreshMileage
    }
  }, [_vm._v("刷新")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal ibox-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("经度")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.devicePosition.lat),
      expression: "devicePosition.lat"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.devicePosition.lat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.devicePosition, "lat", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("纬度")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.devicePosition.lng),
      expression: "devicePosition.lng"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.devicePosition.lng)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.devicePosition, "lng", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("更新时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.devicePosition.gpsTime),
      expression: "devicePosition.gpsTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.devicePosition.gpsTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.devicePosition, "gpsTime", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("当前地址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.devicePosition.address),
      expression: "devicePosition.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.devicePosition.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.devicePosition, "address", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "hr-line-dashed",
    staticStyle: {
      "background": "#DDDDDD",
      "color": "#fff"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal ibox-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*SIM卡号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.deviceInfo.simNum.$error
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.deviceInfo.simNum),
      expression: "deviceInfo.simNum",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "13"
    },
    domProps: {
      "value": (_vm.deviceInfo.simNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "simNum", $event.target.value.trim())
      }, function($event) {
        return _vm.$v.deviceInfo.simNum.$touch()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (!_vm.$v.deviceInfo.simNum.required && _vm.$v.deviceInfo.simNum.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("SIM卡号为必填项")]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("运营商")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.simOperators),
      expression: "deviceInfo.simOperators"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.simOperators)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "simOperators", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("归属地")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.simAttribution),
      expression: "deviceInfo.simAttribution"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.simAttribution)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "simAttribution", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label focus_color"
  }, [_vm._v("*卡类型")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    class: {
      'form-group--error': _vm.$v.deviceInfo.simType.$error
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.simType),
      expression: "deviceInfo.simType"
    }],
    staticClass: "form-control",
    on: {
      "input": function($event) {
        return _vm.$v.deviceInfo.simType.$touch()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.deviceInfo, "simType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.simType), function(option) {
    return _c('option', {
      domProps: {
        "value": option.udccode
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(option.udcname) + "\n\t\t\t\t\t")])
  }), 0), _vm._v(" "), (!_vm.$v.deviceInfo.simType.required && _vm.$v.deviceInfo.simType.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("卡类型为必填项")]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("激活时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.deviceInfo.activeDate),
      expression: "deviceInfo.activeDate",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.deviceInfo.activeDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "activeDate", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("卡资费")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.simCharge),
      expression: "deviceInfo.simCharge"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.simCharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "simCharge", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("代缴期限")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.payPeriodName),
      expression: "deviceInfo.payPeriodName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.payPeriodName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "payPeriodName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("缴费类型")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.paymentModeName),
      expression: "deviceInfo.paymentModeName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.paymentModeName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "paymentModeName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("充值次数")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.rechargeTimes),
      expression: "deviceInfo.rechargeTimes"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.rechargeTimes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "rechargeTimes", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("充值到期时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.expiredDate),
      expression: "deviceInfo.expiredDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.expiredDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "expiredDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("下次充值时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.nextDate),
      expression: "deviceInfo.nextDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.nextDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "nextDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("当前流量(M)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.simBalance),
      expression: "deviceInfo.simBalance"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.simBalance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "simBalance", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.levv == 1) ? _c('span', {
    key: "user-didi",
    staticClass: "input-group-btn"
  }, [(_vm.permissionD.indexOf('fileCarList_deviceDetailRefresh3') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reflashSimBalance
    }
  }, [_vm._v("刷新")]) : _vm._e()]) : _c('span', {
    key: "user-rb",
    staticClass: "input-group-btn"
  }, [(_vm.permission.indexOf('carFileList_deviceDetailRefresh3') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reflashSimBalance
    }
  }, [_vm._v("刷新")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group mb0px"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("所属平台")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.sourceName),
      expression: "deviceInfo.sourceName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.sourceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "sourceName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "hr-line-dashed",
    staticStyle: {
      "background": "#DDDDDD",
      "color": "#fff"
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal ibox-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("安装人")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.installer),
      expression: "deviceInfo.installer"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.installer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "installer", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label"
  }, [_vm._v("安装时间")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.installDate),
      expression: "deviceInfo.installDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.installDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "installDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("安装方式")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.installTypeName),
      expression: "deviceInfo.installTypeName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.installTypeName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "installTypeName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("安装地点")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.installAddress),
      expression: "deviceInfo.installAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.installAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "installAddress", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("安装位置")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deviceInfo.installLocation),
      expression: "deviceInfo.installLocation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.deviceInfo.installLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deviceInfo, "installLocation", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help-block"
  }, [_vm._v("仅用于记录设备的安装位置，仅安装人可见")])])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [(_vm.levv == 1) ? _c('div', {
    key: "user-didi",
    staticClass: "form-group t_center mb0px"
  }, [(_vm.permissionD.indexOf('fileCarList_deviceDetailSave') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.enableSubmit
    },
    on: {
      "click": _vm.saveInfo
    }
  }, [_vm._v("保存")]) : _vm._e()]) : _c('div', {
    key: "user-rb",
    staticClass: "form-group t_center mb0px"
  }, [(_vm.permission.indexOf('carFileList_deviceDetailSave') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.enableSubmit
    },
    on: {
      "click": _vm.saveInfo
    }
  }, [_vm._v("保存")]) : _vm._e()])]), _vm._v(" "), _c('tab-modal', {
    ref: "modal1",
    attrs: {
      "size": "normal",
      "title": _vm.insts[_vm.curInsts].name
    },
    on: {
      "cancel": _vm.closeModal1
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.next),
      expression: "!next"
    }]
  }, [_c('div', [_c(_vm.insts[_vm.curInsts].component, {
    ref: "instComp",
    tag: "component",
    on: {
      "nextClick": _vm.instNextStep,
      "withdrawBtn": _vm.closeModal1
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.next),
      expression: "next"
    }]
  }, [_c('div', [_c('p', [_vm._v("您将要发送" + _vm._s(_vm.insts[_vm.curInsts].name) + "指令")]), _vm._v(" "), _c('p', [_vm._v("确定要继续吗？")])]), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.next) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeModal1
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.next) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.dispatchIns
    }
  }, [_vm._v("确定")]) : _vm._e()])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group mb0px"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label gray t_left"
  }, [_vm._v("无线设备定位上传时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group mb0px"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label gray t_left"
  }, [_vm._v("有线设备定位上传时间")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group mb0px"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label gray t_left"
  }, [_vm._v("SIM卡信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group mb0px"
  }, [_c('label', {
    staticClass: "col-sm-5 control-label gray t_left"
  }, [_vm._v("设备安装信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label "
  }, [_vm._v("安装图片")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17de5841","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/devicedetail/DetailInfo.vue
// module id = 1428
// module chunks = 0